<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <h1>社媒数据推广系统</h1>
      
      </div>

      <el-form
        :model="loginForm"
        :rules="loginRules"
        ref="loginFormRef"
        label-width="0px"
        class="login-form"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="用户名"
            prefix-icon="el-icon-user"
            @keyup.enter="handleLogin"
          ></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="密码"
            prefix-icon="el-icon-lock"
            @keyup.enter="handleLogin"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-checkbox v-model="rememberMe">记住我</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleLogin"
            :loading="loginLoading"
            class="login-button"
          >
            {{ loginLoading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from '@/plugins/request'

export default {
  name: 'Login',
  data() {
    return {
      rememberMe: false,
      loginLoading: false,

      loginForm: {
        username: '',
        password: ''
      },

      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },

  mounted() {
    // 检查是否已登录
    if (this.$store.state.user && this.$store.state.user.id) {
      this.$router.push('/home')
    }

    // 从localStorage恢复记住的用户名
    const savedUsername = localStorage.getItem('savedUsername')
    if (savedUsername) {
      this.loginForm.username = savedUsername
      this.rememberMe = true
    }
  },

  methods: {
    async handleLogin() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return

        this.loginLoading = true
        try {
          const response = await request.post('/api/user/login', {
            username: this.loginForm.username,
            password: this.loginForm.password
          })

          const { access_token, user } = response.data

          // 保存token和用户信息
          localStorage.setItem('access_token', access_token)
          localStorage.setItem('userInfo', JSON.stringify(user))
          localStorage.setItem('userRole', user.username || '')
          
          // 保存用户名用于header显示
          localStorage.setItem('ms_username', user.username || user.nickname)

          // 保存用户名如果勾选了记住我
          if (this.rememberMe) {
            localStorage.setItem('savedUsername', this.loginForm.username)
          } else {
            localStorage.removeItem('savedUsername')
          }

          // 更新Vuex状态
          this.$store.commit('setUser', user)
          this.$store.commit('setToken', access_token)

          this.$message.success('登录成功')
          this.$router.push('/home')
        } catch (error) {
          const message = error.response?.data?.detail || '登录失败，请检查用户名和密码'
          this.$message.error(message)
        } finally {
          this.loginLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url('https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1200&h=800&fit=crop');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.login-container > * {
  position: relative;
  z-index: 2;
}

.login-box {
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 40px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  margin: 0;
  font-size: 28px;
  color: #667eea;
  font-weight: 600;
}

.login-header p {
  margin: 5px 0 0 0;
  font-size: 14px;
  color: #999;
}

.login-form {
  margin: 20px 0;
}

:deep(.login-form .el-form-item) {
  margin-bottom: 22px;
}

:deep(.login-form .el-input) {
  height: 40px;
}

:deep(.login-form .el-input__inner) {
  height: 40px;
  font-size: 14px;
}

:deep(.login-form .el-input__prefix) {
  color: #999;
}

:deep(.login-form .el-checkbox__label) {
  color: #666;
  font-size: 14px;
}

.login-button {
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
  border: none;
}

.login-button:hover {
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
}

@media (max-width: 600px) {
  .login-box {
    margin: 20px;
  }

  .login-header h1 {
    font-size: 24px;
  }
}
</style>
